/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FeedbackApiFrom } from '../../models/feedback-api-from';

export interface ApiV3ServiceGetfeedbackGet$Params {

/**
 * Operation ID.
 */
  operationId?: number;

/**
 * Interface language.
 */
  lang?: string;
}

export function apiV3ServiceGetfeedbackGet(http: HttpClient, rootUrl: string, params?: ApiV3ServiceGetfeedbackGet$Params, context?: HttpContext): Observable<StrictHttpResponse<FeedbackApiFrom>> {
  const rb = new RequestBuilder(rootUrl, apiV3ServiceGetfeedbackGet.PATH, 'get');
  if (params) {
    rb.query('operationId', params.operationId, {});
    rb.query('lang', params.lang, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FeedbackApiFrom>;
    })
  );
}

apiV3ServiceGetfeedbackGet.PATH = '/api/v3/service/getfeedback';
